import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CoursewareService } from 'src/services/CoursewareService';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { first } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  public Registered: boolean = false;

  constructor(private titleService: Title, private coursewareService: CoursewareService, private alertService: AlertService) { 
    this.titleService.setTitle("LawShelf Educational Media");
  }

  ngOnInit() {
  }

  public onSubmit(form: NgForm)
  {
    this.alertService.clear();
    let errorMessage: string = this.getFormErrorMessage(form);
    if (errorMessage){
      this.alertService.error(errorMessage);
      return false;
    }

    this.coursewareService.Register(form.value.Email, form.value.Password, form.value.FirstName, form.value.LastName, form.value.AcceptTerms).subscribe(data => {
      if (data == "Success")
      {
        this.Registered = true;
      } else{
        let error: Error = data;
        this.alertService.error(error.Message);
      }
    });
  }

  public getFormErrorMessage(form: NgForm)
  {
    if (form.value.ConfirmPassword != form.value.Password)
      return "Both passwords must match.";
    if (form.value.FirstName.length < 2 || form.value.FirstName.length > 128)
      return "First name must be longer than 2 characters and shorter than 128.";
    if (form.value.LastName.length < 2 || form.value.LastName.length > 128)
      return "First name must be longer than 2 characters and shorter than 128.";
    if (!form.value.AcceptTerms)
      return "You must accept the terms of service in order to subscribe";
    return null;
  }


  public customFormVerify(form: NgForm)
  {
    if (!form.valid)
      return false;
    let errorMessage: string = this.getFormErrorMessage(form);
    if (errorMessage)
      return false;
    return true;
  }

  public getDisplayLogin()
  {
    if (this.Registered)
      return "none"
    return "inline";
  }

  public getDisplaySuccess()
  {
    if (this.Registered)
      return "inline";
    return "none"
  }
}
